module.exports = __webpack_public_path__ + "media/registry-cover_800.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/registry-cover_800.jpg
// module id = 31
// module chunks = 0